import { faEye } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Tooltip } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { openGoogleStreetviewTab } from "../tools/common"
import { FlexBox } from "./FlexBox"

interface IStreetViewButtonProps {
  latitude: number
  longitude: number
  size?: "1x" | "2x" | "3x"
}

export const StreetViewButton = React.memo(({ latitude, longitude, size }: IStreetViewButtonProps) => (
  <Tooltip title={translate("label.display.google.streetview")} PopperProps={{ style: { zIndex: 14448888880 } }}>
    <span>
      <FlexBox
        sx={{
          "& .icon": {
            cursor: "pointer"
          },
          "& .icon:hover": {
            color: theme => theme.palette.primary.main
          }
        }}>
        <FontAwesomeIcon
          icon={faEye}
          className="icon"
          onClick={() => openGoogleStreetviewTab(latitude, longitude)}
          size={size}
        />
      </FlexBox>
    </span>
  </Tooltip>
))
